import { Card, Typography, Stack, Box } from "@mui/material";
import React, { FC } from "react";
import { WebShopIcon } from "../../WebShopIcon";
import { cn } from "@/src/shared/utils/mergeTwClasses";
import { isEmpty } from "lodash";
import { MobileColumnCardProps } from "../lib/type";
import { ParsedValue } from "../../TextWithValue";
import { ButtonLoader } from "@/src/components/Loaders";
import { getProposalColumnDisplayLabel } from "../lib/utils";

export const MobileColumnCard: FC<MobileColumnCardProps> = ({
  onClick,
  isSelected,
  title,
  icon,
  price,
  loading = false,
  pointerEventsNone = false,
}) => {
  const { label, subLabel } = getProposalColumnDisplayLabel(title);
  return (
    <Card
      onClick={onClick}
      className={cn("h-full w-full cursor-pointer p-2", {
        "outline outline-2 outline-blue transition-all": isSelected,
        "pointer-events-none": pointerEventsNone,
      })}
    >
      <Stack className="h-full items-center gap-3">
        {title && (
          <Typography className="text-xs font-semibold uppercase text-dark-blue">
            {label}
          </Typography>
        )}
        {subLabel && (
          <Typography className="text-xs font-semibold text-dark-blue">
            {subLabel}
          </Typography>
        )}
        {!isEmpty(icon) && (
          <Box
            className="flex flex-1 items-center justify-center"
            style={{
              width: icon.width,
              height: icon.height,
            }}
          >
            <WebShopIcon
              name={icon.name}
              width={icon.width}
              height={icon.height}
            />
          </Box>
        )}
        {price && (
          <Typography className="text-xl font-bold text-dark-blue">
            <ParsedValue value={price} maskType="thousandSeparator" />
          </Typography>
        )}
        <Box
          className={cn(
            `ml-auto flex items-center justify-center rounded-full border border-solid border-gray-400 transition-all max-mdPlus:h-6 max-mdPlus:w-6 max-sm:h-4 max-sm:w-4`,
            {
              "border-blue bg-blue": isSelected && !loading,
              "border-transparent bg-transparent": loading,
            },
          )}
        >
          {loading && (
            <ButtonLoader className={"border-t-blue border-r-blue"}/>
          )}
          {isSelected && !loading &&  (
            <WebShopIcon
              name="check"
              className="fill-white stroke-white max-mdPlus:h-3 max-mdPlus:w-3 max-sm:h-[10px] max-sm:w-[10px]"
            />
          )}
        </Box>
      </Stack>
    </Card>
  );
};
